export function formatNumber(num: number) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(0).replace(/\.0$/, '') + 'K';
  } else {
    return num.toString();
  }
}

const BYTES_PER_MB = 1024 * 1024;

/** Dateigröße für eine Tabellenzelle: B / KB / MB / GB, deutsche Schreibweise.
 *  1024er-Basis wie die Speicher-Kachel (`usage.component.ts::getMegaBytes`),
 *  damit die Summe markierter Dateien zur Kachel passt. Ohne Wert (ältere
 *  Zeilen haben keine Größe) bleibt die Zelle leer statt "0 B" zu behaupten. */
export function formatFileSize(bytes: number | null | undefined): string {
  if (bytes == null || !Number.isFinite(bytes)) return '';
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit++;
  }
  const digits = value < 10 ? 1 : 0;
  return `${value.toLocaleString('de-DE', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })} ${units[unit]}`;
}

/** Bytes als MB mit zwei Nachkommastellen — dieselbe Einheit und Genauigkeit
 *  wie die Speicher-Kachel ("5.148,52/500"). */
export function formatMegabytes(bytes: number): string {
  return `${(bytes / BYTES_PER_MB).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} MB`;
}

export function intToTime(seconds: number): string {
  let hrs = Math.floor(seconds / 3600);
  let mins = Math.floor((seconds % 3600) / 60);
  let secs = seconds % 60;

  // round all to 0 decimal places
  hrs = Math.round(hrs);
  mins = Math.round(mins);
  secs = Math.round(secs);

  return [hrs, mins, secs]
    .map((v) => (v < 10 ? '0' + v : v))
    .filter((v, i) => v !== '00' || i > 0)
    .join(':');
}
